import { themes } from 'signer-app/white-labeling/themes';
import type { WhiteLabelStyles } from 'signer-app/white-labeling/types';

export const whiteLabelingNew: WhiteLabelStyles = themes.vis2023;

export type WhiteLabelingPropertyIdNew = keyof typeof whiteLabelingNew;
